import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      titleFaq="よくある質問"
      items={[
        {
          question: 'サイエンスイラストレーションとは？',
          answer:
            ' 科学図または科学イラストは、視覚的なリソースを通じて科学研究の結果を伝えるための創造的な方法です。より多くの人々が科学とつながりやすく、アクセスしやすく、便利で、理解しやすいスタイルで科学を提示する方法です。',
        },
        {
          question: ' 優れた科学イラストを作成するには?',
          answer:
            '優れた科学イラストを作成するには、目標と読者を定義し、強力な概要を設定し、主要なデータとは何か、読者が理解しなければならない最も重要な情報とは何かを理解して、わかりやすい科学イラストを作成する必要があります。余分な説明や内容なしで、読むだけでわかるようにすることがポイントです。',
        },
        {
          question: ' 優れた科学イラストには何を含める必要がありますか?',
          answer:
            '優れた科学イラストには、テキスト、ビジュアル、デザインの組み合わせが含まれており、相互に補完して読解力を向上させます。優れた科学イラストは、研究に関するすべての関連情報を明確かつ視覚的に心地よい方法で示し、読者が自分で理解できるようにします。',
        },
        {
          question: '優れた科学イラストをどこで作成できますか?',
          answer:
            'Mind The Graph は、科学イラストを作成するための最高の無料プラットフォームです。一貫したアート スタイル、科学的に正確なイラスト、直感的な読み取りフローを備えたテンプレート、グラフィック、記号、アイコン、および適切なフォント スタイルを備えた科学グラフィックを作成できます。また、ジャーナル、雑誌、ブログ、ソーシャル メディア、書籍などで、Mind The Graph でデザインしたサイエンス イラストを公開することもできます。',
        },
      ]}
    />
  );
}
